import React from 'react';

import { AlertHeading, Alert as BoostrapAlert } from 'react-bootstrap';

import { AlertVariantT } from '@consumer-frontend/nc-utils';

import { Icon } from '../Icon';
import { AllowedIconNameT } from '../Icon/allowedIcons';

import '@consumer-bootstrap/components/alerts.scss';

export const ALERT_VARIANTS: AlertVariantT[] = [
  'warning',
  'info',
  'danger',
  'success',
];
export type AlertVariantIconNameMapT = { [key in AlertVariantT]: AllowedIconNameT; };
export const ALERT_VARIANT_ICON_NAME_MAP: AlertVariantIconNameMapT = {
  danger: 'exclamation-circle',
  info: 'info-circle',
  success: 'check-circle',
  warning: 'exclamation-triangle',
};

export type AlertPropsT = {
  variant: AlertVariantT;
  children?: React.ReactNode;
  chromaticIgnore?: boolean;
  className?: string;
  dismissible?: boolean;
  header?: React.ReactNode;
};
export type AlertT = React.FC<AlertPropsT>;

export const Alert: AlertT = ({
  children,
  chromaticIgnore,
  className,
  dismissible,
  header,
  variant,
}) => {
  return (
    <BoostrapAlert
      className={`d-flex ${className}`}
      dismissible={dismissible}
      variant={variant}
    >
      <div className="alert-icon-container">
        <Icon className="alert-icon" iconName={ALERT_VARIANT_ICON_NAME_MAP[variant]} />
      </div>
      <div
        className="body-container"
        data-chromatic={chromaticIgnore ? 'ignore' : undefined}
      >
        {header
          ? (
            <AlertHeading as="div" className="h6">
              {header}
            </AlertHeading>
          )
          : null}

        {children}
      </div>
    </BoostrapAlert>
  );
};
